
// ob- Product Content - Block Rating
// - Getting all product`s review number from Opiniões Verificadas app
(function (document) {
	const handleReviewsCount = () => {
		const rawProd = document.querySelector('.NETREVIEWS_PRODUCT_STARS');
		const productId = rawProd.getAttribute('data-product-id');
		const storedReviews = sessionStorage.getItem(productId);
		if (storedReviews) {
			const parsedReviews = JSON.parse(storedReviews);
			const stats = parsedReviews[0].stats;
			const totalReviews = stats[0] + stats[1] + stats[2] + stats[3] + stats[4];
			// target selectors
			const targetDesk = document.querySelector('.ob-review-number');
			const targetMobile = document.querySelector('.ob-review-number-mobile');
			
			if (targetDesk) {
				targetDesk.innerHTML = `(${totalReviews})`;
			}
			if (targetMobile) {
				targetMobile.innerHTML = `(${totalReviews})`;
			}
		}
	};
			
	document.addEventListener('scriptReviews:loaded', (event) => {
		const load = event.detail.load;
		if (load) {
			handleReviewsCount();
		}
	});
})(document);
